<header class="header-bar">
  <div class="header-school">
    <div class="school-mark">
      @if (schoolLogoUrl) {
        <img class="school-logo" [src]="schoolLogoUrl" alt="School logo" (error)="handleLogoError()" />
      } @else {
        <i class="fas fa-school"></i>
      }
    </div>
    <div class="school-copy" data-guide="shell-school">
      <span class="school-kicker">{{ orgKicker }}</span>
      <span class="school-name">{{ schoolName }}</span>
    </div>
    @if (schoolSwitchVisible) {
      <div class="school-divider"></div>
      <button class="btn-change btn-change--compact" (click)="openSchoolChange()" title="Switch school">
        <i class="fas fa-exchange-alt"></i>
      </button>
    }
    <div class="header-spacer"></div>

    <!-- App-specific header widgets (e.g. Academics academic-year picker). -->
    <ng-content select="[headerActions]"></ng-content>

    <!-- Hidden in an app that has not turned the Guide on. -->
    <spectrum-guide-button />

    <div class="profile-switcher" data-guide="shell-profile" (click)="toggleProfileMenu($event)">
      <button class="profile-switcher__trigger" type="button" [class.profile-switcher__trigger--active]="showProfileMenu">
        <span class="profile-switcher__avatar">{{ initials }}</span>
        <span class="profile-switcher__copy">
          <span class="profile-switcher__name">{{ employeeName }}</span>
        </span>
        <i class="fas fa-chevron-down profile-switcher__chevron" [class.profile-switcher__chevron--open]="showProfileMenu"></i>
      </button>

      @if (showProfileMenu) {
        <div class="profile-menu" (click)="$event.stopPropagation()">
          <div class="profile-menu__header">
            <span class="profile-menu__avatar">{{ initials }}</span>
            <div class="profile-menu__copy">
              <span class="profile-menu__eyebrow">Signed in as</span>
              <span class="profile-menu__name">{{ employeeName }}</span>
              <span class="profile-menu__school">{{ schoolName }}</span>
            </div>
          </div>
          <div class="profile-menu__status">
            <span class="profile-menu__status-dot"></span>
            <span>{{ sessionLabel }} session active</span>
          </div>
          <div class="profile-menu__divider"></div>
          <button class="profile-menu__item" type="button" (click)="openMyProfile()">
            <span class="profile-menu__item-icon">
              <i class="fas fa-user"></i>
            </span>
            <span class="profile-menu__item-copy">
              <strong>My Profile</strong>
              <small>Account and profile details</small>
            </span>
            <i class="fas fa-chevron-right profile-menu__item-arrow"></i>
          </button>
          <button class="profile-menu__item profile-menu__item--danger" type="button" (click)="logout()">
            <span class="profile-menu__item-icon">
              <i class="fas fa-sign-out-alt"></i>
            </span>
            <span class="profile-menu__item-copy">
              <strong>Logout</strong>
              <small>End this browser session</small>
            </span>
            <i class="fas fa-chevron-right profile-menu__item-arrow"></i>
          </button>
        </div>
      }
    </div>
  </div>
</header>

@if (showSchoolChange) {
  <spectrum-school-change (closed)="closeSchoolChange()" />
}
